var map = {
	"./icon-attacking-shot.svg": 180,
	"./icon-batting-style.svg": 804,
	"./icon-birthday.svg": 805,
	"./icon-cross.svg": 806,
	"./icon-defensive-shot.svg": 337,
	"./icon-edit.svg": 807,
	"./icon-email.svg": 808,
	"./icon-facebook-login.svg": 809,
	"./icon-gender.svg": 810,
	"./icon-google-login.svg": 811,
	"./icon-grip-style.svg": 812,
	"./icon-height.svg": 813,
	"./icon-horizontal-bat.svg": 333,
	"./icon-off-side.svg": 334,
	"./icon-on-side.svg": 335,
	"./icon-phone.svg": 814,
	"./icon-powerful-shot.svg": 240,
	"./icon-refresh.svg": 815,
	"./icon-straight.svg": 336,
	"./icon-vertical-bat.svg": 332,
	"./icon-weight.svg": 816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 442;